"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _OnDemandTranslations = require("./OnDemandTranslations");

Object.keys(_OnDemandTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _OnDemandTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _OnDemandTranslations[key];
    }
  });
});

var _Feedback = require("./Feedback");

Object.keys(_Feedback).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Feedback[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Feedback[key];
    }
  });
});